import React from 'react'
import PropTypes from 'prop-types'
import { getImage, GatsbyImage } from 'gatsby-plugin-image'
import { BgImage } from 'gbimage-bridge'
import ButtonInscription from './ButtonInscription'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons'

const SimpleBanner = ({
  image,
  text,
  subText,
  buttonText = null,
  link,
  linkContacto,
  category,
  date,
  dateEndInscr,
  icon,
  imageDefault,
  localButtonText,
  localLink,
  label
}) => {
  const banner = getImage(image?.localFile)
  const iconBanner = getImage(icon?.localFile)
  const imgDefault = getImage(imageDefault?.localFile)

  return (
    <div className="slide slide__Item">
      <BgImage image={banner ? banner : imgDefault} className="slide__bgImage">
        {label && (
          <div className="simple-banner-label">
            <FontAwesomeIcon icon={faGraduationCap} size="md" />
            <p>{label}</p>
          </div>
        )}
        <div className="slide__content" style={{ minHeight: 465 }}>
          {category && <p>{category}</p>}
          {icon && <GatsbyImage image={iconBanner} />}
          {text && <h2 className="font-weight-extra-bold">{text}</h2>}
          {subText && <p>{subText}</p>}
          {date && <p>{date}</p>}

          <div className='d-flex flex-wrap justify-content-center align-items-center'>
            {dateEndInscr && (
              <ButtonInscription
                dateEndInscr={dateEndInscr}
                link={link}
                linkContacto={linkContacto}
                buttonText={buttonText}
              />
            )}
            {localButtonText && (
              <Link
                to={localLink}
                className="btn btn-outline-lighter rounded-pill px-3 simple-banner-local-btn"
              >
                {localButtonText}
              </Link>
            )}
          </div>
        </div>
      </BgImage>
    </div>
  )
}

export default SimpleBanner

SimpleBanner.propTypes = {
  image: PropTypes.object,
  text: PropTypes.string,
  subText: PropTypes.string,
  link: PropTypes.string,
  category: PropTypes.string,
  date: PropTypes.string,
  dateEndInscr: PropTypes.string,
  icon: PropTypes.object,
  imageDefault: PropTypes.object,
  localButtonText: PropTypes.string,
  localLink: PropTypes.string,
  label: PropTypes.string
}
